

// import { Height } from "@mui/icons-material";
// import { useState } from "react";


// const LicensesDocuments = ({ formData, setFormData, onNext, onBack, onSubmitScroll }) => {
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const handleFileChange = (key, file) => {
//         setFormData({
//             ...formData,
//             [key]: file,
//             [`${key}Preview`]: URL.createObjectURL(file) // 🔥 preview URL
//         });
//     };

//     return (
//         <div style={cardStyle}>


//             <div style={rowStyle}>

//                 {/* GST */}
//                 <div style={field}>
//                     <h4 style={sectionTitle}>GST Details</h4>

//                     <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>

//                         {/* GST Input */}
//                         <input
//                             style={{ ...input, flex: 1 }}
//                             value={formData.gst || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, gst: e.target.value })
//                             }
//                             placeholder="Enter GST number"
//                         />

//                         {/* File Upload */}
//                         <input
//                             type="file"
//                             style={{ ...input, flex: 1 }}
//                             onChange={(e) => handleFileChange("gstFile", e.target.files[0])}
//                         />

//                     </div>
//                 </div>
//                 {/* PAN */}
//                 <div style={field}>
//                     <h4 style={sectionTitle}>Company PAN Details</h4>

//                     <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>

//                         {/* PAN Input */}
//                         <input
//                             style={{ ...input, flex: 1 }}
//                             value={formData.pan || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, pan: e.target.value })
//                             }
//                             placeholder="Enter PAN number"
//                         />

//                         {/* File Upload */}
//                         <input
//                             type="file"
//                             style={{ ...input, flex: 1 }}
//                             onChange={(e) => handleFileChange("panFile", e.target.files[0])}
//                         />

//                     </div>
//                 </div>


//                 <div style={field}>
//                     <div >
//                         <h4 style={sectionTitle}>Trade License</h4>

//                         <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>

//                             {/* Trade License Number */}
//                             <input
//                                 style={{ ...input, flex: 1 }}
//                                 value={formData.tradeLicenseNo || ""}
//                                 onChange={(e) =>
//                                     setFormData({ ...formData, tradeLicenseNo: e.target.value })
//                                 }
//                                 placeholder="Enter Trade License No"
//                             />

//                             {/* File Upload */}
//                             <input
//                                 type="file"
//                                 style={{ ...input, flex: 1 }}
//                                 onChange={(e) => handleFileChange("tradeLicenseFile", e.target.files[0])}
//                             />

//                         </div>
//                     </div>
//                     <div style={dateRow}>
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.tradeStart || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, tradeStart: e.target.value })
//                             }
//                         />
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.tradeEnd || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, tradeEnd: e.target.value })
//                             }
//                         />
//                     </div>


//                 </div>

//                 {/* FSSAI */}
//                 {/* <div style={field}>
//                     <h4 style={sectionTitle}>FSSAI License</h4>

//                     <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>

//                         <input
//                             style={{ ...input, flex: 1 }}
//                             value={formData.fssaiNo || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, fssaiNo: e.target.value })
//                             }
//                             placeholder="Enter FSSAI No"
//                         />

//                         <input
//                             type="file"
//                             style={{ ...input, flex: 1 }}
//                             onChange={(e) => handleFileChange("fssaiFile", e.target.files[0])}
//                         />

//                     </div>
//                     <div style={dateRow}>
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.fssaiStart || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, fssaiStart: e.target.value })
//                             }
//                         />
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.fssaiEnd || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, fssaiEnd: e.target.value })
//                             }
//                         />
//                     </div>


//                 </div> */}

//                 {/* Labour License */}
//                 <div style={field}>
//                     <h4 style={sectionTitle}>Labour License</h4>

//                     <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>

//                         {/* Labour License Number */}
//                         <input
//                             style={{ ...input, flex: 1 }}
//                             value={formData.labourLicenseNo || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, labourLicenseNo: e.target.value })
//                             }
//                             placeholder="Enter Labour License No"
//                         />

//                         {/* File Upload */}
//                         <input
//                             type="file"
//                             style={{ ...input, flex: 1 }}
//                             onChange={(e) => handleFileChange("labourFile", e.target.files[0])}
//                         />

//                     </div>
//                     <div style={dateRow}>
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.labourStart || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, labourStart: e.target.value })
//                             }
//                         />
//                         <input
//                             type="date"
//                             style={dateInput}
//                             value={formData.labourEnd || ""}
//                             onChange={(e) =>
//                                 setFormData({ ...formData, labourEnd: e.target.value })
//                             }
//                         />
//                     </div>


//                 </div>

//             </div>
//             {/* Bank Details */}
//             <div style={field}>
//                 <h4 style={sectionTitle}>Bank Details</h4>

//                 {/* Row 1 */}
//                 <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>

//                     {/* Bank Name */}
//                     <input
//                         style={{ ...input, flex: 1 }}
//                         value={formData.bankName || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, bankName: e.target.value })
//                         }
//                         placeholder="Enter Bank Name"
//                     />

//                     {/* IFSC Code */}
//                     <input
//                         style={{ ...input, flex: 1 }}
//                         value={formData.ifsc || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, ifsc: e.target.value })
//                         }
//                         placeholder="Enter IFSC Code"
//                     />

//                 </div>

//                 {/* Row 2 */}
//                 <div style={{ display: "flex", gap: "15px", marginTop: "10px", flexWrap: "wrap" }}>

//                     {/* Account Number */}
//                     <input
//                         style={{ ...input, flex: 1 }}
//                         value={formData.accountNumber || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, accountNumber: e.target.value })
//                         }
//                         placeholder="Enter Account Number"
//                     />

//                     {/* Upload Passbook */}
//                     <input
//                         type="file"
//                         style={{ ...input, flex: 1 }}
//                         onChange={(e) =>
//                             handleFileChange("passbookFile", e.target.files[0])
//                         }
//                     />

//                 </div>

//                 {/* Optional: show file name */}
//                 {formData.passbookFile && (
//                     <p style={{ fontSize: "12px", marginTop: "6px", color: "green" }}>
//                         ✔ {formData.passbookFile.name}
//                     </p>
//                 )}
//             </div>

//             <div style={{ textAlign: "center", marginTop: "30px" }}>

//                 <button
//                     onClick={onBack}
//                     style={{
//                         background: "#6b7280",
//                         color: "#fff",
//                         padding: "10px 20px",
//                         borderRadius: "8px",
//                         border: "none",
//                         cursor: "pointer",
//                         marginRight: "10px"
//                     }}
//                 >
//                     ← Back
//                 </button>

//                 <button style={nextBtn} onClick={onNext}>
//                     Next →
//                 </button>

//             </div>


//         </div>
//     );
// };

// export default LicensesDocuments;

// // ===== STYLES =====
// const dateRow = {
//     display: "flex",
//     gap: "8px",
//     marginTop: "8px"
// };

// const dateInput = {
//     flex: 1,
//     padding: "6px",
//     borderRadius: "6px",
//     border: "1px solid #d1d5db"
// };

// const cardStyle = {
//     background: "#fff",
//     // padding: "24px",
//     borderRadius: "12px",
//     height:
//         window.innerWidth >= 1000 && window.innerWidth <= 1400
//             ? "335px"
//             : "420px",
//     overflow: "auto",
//     scrollbarWidth: "none"
// };

// const title = {
//     fontSize: "16px",
//     fontWeight: "600",
//     marginBottom: "15px",
// };

// const rowStyle = {
//     display: "flex",
//     flexDirection: "column", // 🔥 vertical layout
//     // gap: "20px"
// };

// const field = {
//     width: "80%",
//     padding: "16px",
//     borderRadius: "10px",
//     marginBottom: "-10px"
//     // border: "1px solid #e5e7eb",
//     // background: "#f9fafb",
//     // boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
// };

// const sectionTitle = {
//     fontSize: "14px",
//     fontWeight: "600",
//     marginBottom: "10px",
//     color: "#111827"
// };

// const label = {
//     fontSize: "13px",
//     fontWeight: "600",
//     marginBottom: "6px",
//     display: "block",
// };

// const input = {
//     width: "100%",
//     padding: "7px",
//     borderRadius: "8px",
//     border: "1px solid #d1d5db",
//     background: "#f9fafb",
// };

// const fileInput = {
//     marginTop: "8px",
//     width: "100%",
//     padding: "6px",
//     borderRadius: "6px",
//     border: "1px solid #d1d5db",
//     background: "#fff"
// };
// const nextBtn = {
//     background: "#f97316",
//     color: "#fff",
//     padding: "10px 30px",
//     borderRadius: "10px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: "600",
// };



import React, { useState, useEffect } from "react";
import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
import { useLoader } from "../../../context/LoaderProvider";

const LicensesDocuments = ({ formData, setFormData, onNext, onBack }) => {
    const [loading, setLoading] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    // Helper function to extract filename from URL
    const getFileNameFromUrl = (url) => {
        if (!url) return null;
        try {
            const urlParts = url.split('/');
            let filename = urlParts[urlParts.length - 1];
            filename = filename.split('?')[0];
            filename = decodeURIComponent(filename);
            if (filename.length > 30) {
                filename = filename.substring(0, 27) + '...';
            }
            return filename;
        } catch (e) {
            return "Document";
        }
    };

    useEffect(() => {
        const fetchVendorData = async () => {
            try {
                showLoader();
                const vendorId = localStorage.getItem("vendorId");
                if (!vendorId) return;
                
                const data = await getEngineeringVendorById(vendorId);
                
                if (data && Object.keys(data).length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        gst: data.gstNumber || "",
                        gstFilePreview: data.gstImage || "",
                        pan: data.panCardNumber || "",
                        panFilePreview: data.panCard || "",
                        tradeLicenseNo: data.tradeLicenseNumber || "",
                        tradeLicenseFilePreview: data.tradeLicense || "",
                        tradeStart: data.tradeLicenseStartDate || "",
                        tradeEnd: data.tradeLicenseEndDate || "",
                        labourLicenseNo: data.labourLicenseNumber || "",
                        labourFilePreview: data.labourLicense || "",
                        labourStart: data.labourStartDate || "",
                        labourEnd: data.labourEndDate || "",
                        bankName: data.bankName || "",
                        ifsc: data.ifscCode || "",
                        accountNumber: data.bankAccountNumber || "",
                        passbookFilePreview: data.passbookImage || ""
                    }));
                }
            } catch (error) {
                console.error("Error fetching licenses data:", error);
            } finally {
                hideLoader();
            }
        };
        fetchVendorData();
    }, []);

    const UploadBox = ({ labelText, fileKey, previewKey }) => {
        const hasExistingPreview = formData[previewKey] && !formData[fileKey];
        const existingFileName = hasExistingPreview ? getFileNameFromUrl(formData[previewKey]) : null;
        
        return (
            <div style={uploadWrapper}>
                <label style={label}>{labelText}</label>
                <input type="file" id={`upload-${fileKey}`} style={{ display: "none" }} onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        setFormData({ ...formData, [fileKey]: file, [previewKey]: URL.createObjectURL(file) });
                    }
                }} />
                <label htmlFor={`upload-${fileKey}`} style={uploadBoxStyle}>
                    {formData[previewKey] ? (
                        <div style={filePreviewContainer}>
                            <div style={fileInfo}>
                                <span style={tickMark}>✓</span>
                                <span style={existingFileName ? fileNameGreen : fileNameText}>
                                    {existingFileName || (formData[fileKey] ? formData[fileKey].name : "Document uploaded")}
                                </span>
                            </div>
                            <span style={uploadTextSmall}>{hasExistingPreview ? "Click to change file" : "Click to change file"}</span>
                        </div>
                    ) : (
                        <div style={uploadContent}>
                            <span style={uploadText}>Click to upload {labelText}</span>
                        </div>
                    )}
                </label>
                {formData[fileKey] && !hasExistingPreview && (
                    <p style={fileNameText}>✔ {formData[fileKey].name}</p>
                )}
            </div>
        );
    };

    return (
        <div style={cardStyle}>
            <h3 style={mainTitle}>Documents & Licenses</h3>

            {/* GST */}
            <div style={sectionCard}>
                <h4 style={sectionTitle}>GST Details</h4>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>GST Number</label>
                        <input style={input} value={formData.gst || ""} onChange={(e) => setFormData({ ...formData, gst: e.target.value })} placeholder="Enter GST number" />
                    </div>
                    <div style={fieldHalf}>
                        <UploadBox labelText="GST Document" fileKey="gstFile" previewKey="gstFilePreview" />
                    </div>
                </div>
            </div>

            {/* PAN */}
            <div style={sectionCard}>
                <h4 style={sectionTitle}>PAN Details</h4>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>PAN Number</label>
                        <input style={input} value={formData.pan || ""} onChange={(e) => setFormData({ ...formData, pan: e.target.value })} placeholder="Enter PAN number" />
                    </div>
                    <div style={fieldHalf}>
                        <UploadBox labelText="PAN Document" fileKey="panFile" previewKey="panFilePreview" />
                    </div>
                </div>
            </div>

            {/* Trade License */}
            <div style={sectionCard}>
                <h4 style={sectionTitle}>Trade License</h4>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>License Number</label>
                        <input style={input} value={formData.tradeLicenseNo || ""} onChange={(e) => setFormData({ ...formData, tradeLicenseNo: e.target.value })} placeholder="Enter Trade License number" />
                    </div>
                    <div style={fieldHalf}>
                        <UploadBox labelText="Trade License Document" fileKey="tradeLicenseFile" previewKey="tradeLicenseFilePreview" />
                    </div>
                </div>
                <div style={dateRow}>
                    <div style={fieldHalf}>
                        <label style={label}>Start Date</label>
                        <input type="date" style={dateInput} value={formData.tradeStart || ""} onChange={(e) => setFormData({ ...formData, tradeStart: e.target.value })} />
                    </div>
                    <div style={fieldHalf}>
                        <label style={label}>End Date</label>
                        <input type="date" style={dateInput} value={formData.tradeEnd || ""} onChange={(e) => setFormData({ ...formData, tradeEnd: e.target.value })} />
                    </div>
                </div>
            </div>

            {/* Labour License */}
            <div style={sectionCard}>
                <h4 style={sectionTitle}>Labour License</h4>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>License Number</label>
                        <input style={input} value={formData.labourLicenseNo || ""} onChange={(e) => setFormData({ ...formData, labourLicenseNo: e.target.value })} placeholder="Enter Labour License number" />
                    </div>
                    <div style={fieldHalf}>
                        <UploadBox labelText="Labour License Document" fileKey="labourFile" previewKey="labourFilePreview" />
                    </div>
                </div>
                <div style={dateRow}>
                    <div style={fieldHalf}>
                        <label style={label}>Start Date</label>
                        <input type="date" style={dateInput} value={formData.labourStart || ""} onChange={(e) => setFormData({ ...formData, labourStart: e.target.value })} />
                    </div>
                    <div style={fieldHalf}>
                        <label style={label}>End Date</label>
                        <input type="date" style={dateInput} value={formData.labourEnd || ""} onChange={(e) => setFormData({ ...formData, labourEnd: e.target.value })} />
                    </div>
                </div>
            </div>

            {/* Bank Details */}
            <div style={sectionCard}>
                <h4 style={sectionTitle}>Bank Details</h4>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>Bank Name</label>
                        <input style={input} value={formData.bankName || ""} onChange={(e) => setFormData({ ...formData, bankName: e.target.value })} placeholder="Enter bank name" />
                    </div>
                    <div style={fieldHalf}>
                        <label style={label}>IFSC Code</label>
                        <input style={input} value={formData.ifsc || ""} onChange={(e) => setFormData({ ...formData, ifsc: e.target.value })} placeholder="Enter IFSC code" />
                    </div>
                </div>
                <div style={rowStyle}>
                    <div style={fieldHalf}>
                        <label style={label}>Account Number</label>
                        <input style={input} value={formData.accountNumber || ""} onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })} placeholder="Enter account number" />
                    </div>
                    <div style={fieldHalf}>
                        <UploadBox labelText="Passbook / Cheque" fileKey="passbookFile" previewKey="passbookFilePreview" />
                    </div>
                </div>
            </div>

            {/* Buttons */}
            <div style={buttonContainer}>
                <button style={backBtn} onClick={onBack}>← Back</button>
                <button style={nextBtn} onClick={onNext}>Save & Next →</button>
            </div>
        </div>
    );
};

export default LicensesDocuments;

// Styles
const cardStyle = { background: "#fff", borderRadius: "12px", overflow: "auto", scrollbarWidth: "none", paddingRight: "8px" };
const mainTitle = { fontSize: "16px", fontWeight: "600", marginBottom: "20px", color: "#111827" };
const sectionCard = { background: "#fff", borderRadius: "10px", marginBottom: "0px", padding: "16px", border: "0px solid #e5e7eb" };
const sectionTitle = { fontSize: "14px", fontWeight: "600", marginBottom: "16px", color: "#111827" };
const rowStyle = { display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "0px" };
const fieldHalf = { flex: 1, minWidth: "200px" };
const label = { fontSize: "13px", fontWeight: "600", marginBottom: "6px", display: "block", color: "#374151" };
const input = { width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #d1d5db", background: "#f9fafb", fontSize: "13px", boxSizing: "border-box" };
const dateRow = { display: "flex", gap: "20px", flexWrap: "wrap", marginTop: "15px" };
const dateInput = { width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #d1d5db", background: "#f9fafb", fontSize: "13px", boxSizing: "border-box" };
const uploadWrapper = { width: "100%" };
const uploadBoxStyle = { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", minHeight: "40px", padding:"1px 0px 0px 1px", border: "2px dashed #d1d5db", borderRadius: "12px", background: "#fafbfc", cursor: "pointer", transition: "0.2s", marginTop: "0px", boxSizing: "border-box" };
const uploadContent = { display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", padding: "0px" };
const uploadText = { fontSize: "12px", color: "#6b7280", textAlign: "center" };
const uploadTextSmall = { fontSize: "10px", color: "#9ca3af", textAlign: "center", marginTop: "4px" };

// New styles for file display with green tick
const filePreviewContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 5px",
    width: "100%"
};

const fileInfo = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "#f0fdf4",
    padding: "6px 12px",
    borderRadius: "8px",
    border: "1px solid #bbf7d0",
    marginBottom: "0px"
};

const tickMark = {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#22c55e"
};

const fileNameGreen = {
    fontSize: "12px",
    fontWeight: "500",
    color: "#166534",
    fontFamily: "monospace",
    wordBreak: "break-all"
};

const fileNameText = {
    fontSize: "11px",
    color: "#10b981",
    marginTop: "6px"
};

const buttonContainer = { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" };
const backBtn = { background: "#6b7280", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };
const nextBtn = { background: "#f97316", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };